export function toOptions<T, L = T, V = T>(
  arr: T[],
  options?: {
    labelTransformerFn?: (item: T) => L;
    valueTransformerFn?: (item: T) => V;
  },
) {
  const { labelTransformerFn, valueTransformerFn } = options || {};

  return arr.map((item) => ({
    label: labelTransformerFn ? labelTransformerFn(item) : (item as unknown as L),
    value: valueTransformerFn ? valueTransformerFn(item) : (item as unknown as V),
  }));
}
